import { connect } from 'react-redux'
import License from './License.jsx'
import {
    getVisualizerLicenseText,
    isLicenseEnabled,
} from '../../../../redux/app/selectors'

const mapStateToProps = state => ({
    isLicenseEnabled: isLicenseEnabled(state),
    licenseText: getVisualizerLicenseText(state)
})

export const LicenseContainer = connect(
    mapStateToProps,
)(License)
